import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2';
import "../scss/card.css";
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { GeneratePdf } from '../components/GeneratePdf';
import VidyaUpasnaLogo from '../assets/VidyaUpasna.jpg';

const AIBasedTeachingReport = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const initialFormState = {
        syllabusStructureMasterId: '',
        subjectMasterId: '',
        lessonMasterId: '',
        details: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [teachingData, setTeachingData] = useState(initialFormState)
    const [teachingPlan, setTeachingPlan] = useState([])
    const [editId, setEditId] = useState(null)

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        getTeachingPlan();
    }, [teachingData.syllabusStructureMasterId, teachingData.subjectMasterId, teachingData.lessonMasterId]);

    const getTeachingPlan = async () => {
        if (teachingData.syllabusStructureMasterId.length !== 0 && teachingData.subjectMasterId.length !== 0/* && teachingData.lessonMasterId.length !== 0*/) {
            let apiUrl = '/view-teaching-plan?';
            if (teachingData.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${teachingData.syllabusStructureMasterId}&`;
            }
            if (teachingData.subjectMasterId) {
                apiUrl += `subjectMasterId=${teachingData.subjectMasterId}&`
            }
            if (teachingData.lessonMasterId) {
                apiUrl += `lessonMasterId=${teachingData.lessonMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            try {
                const response = await authorizedAxios.get(apiUrl);
                setTeachingPlan(response.data.result);
            } catch (error) {
                setTeachingPlan({});
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                lessonMasterId: ''
            }
        })
        setLessonList([]);

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: ''
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${teachingData.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setTeachingData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleDetailChange = (editor) => {
        let value = editor.getData();
        setTeachingData((prevData) => {
            return {
                ...prevData,
                details: value
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(teachingData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(teachingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [teachingData])

    const addTeachingPlan = async () => {
        if (validateForm()) {
            setLoading(true);
            const apiUrl = `/add-teaching-plan`;
            try {
                const response = await authorizedAxios.post(apiUrl, teachingData);
                await getTeachingPlan();
                setTeachingData((prevData) => {
                    return {
                        ...prevData,
                        details: ''
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(teachingData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }


    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    setLoading(true);
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.response.data.error);
                            })
                            .finally(() => {
                                setLoading(false); // End loading
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    const handleInputReset = () => {
        setTeachingData(initialFormState);
        setTeachingPlan([]);
        setEditId('');
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>AI Based Teaching Report</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-robot"></i>AI Based Teaching Report</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={teachingData.syllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusStructureMasterId && <p style={{ color: 'red' }}>{error.syllabusStructureMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={teachingData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleInputChange} value={teachingData.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.lessonMasterId && <p style={{ color: 'red' }}>{error.lessonMasterId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {/* {
                                                            !editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTeachingPlan}>Show</button>
                                                        } */}
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                        {/* {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTeachingPlan} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                {teachingPlan && teachingPlan.length !== 0 &&
                                                    <div className="content_book_wraper">
                                                        <div className="header_group">
                                                            <GeneratePdf id="AIBasedTeachingReport" title={teachingPlan} />
                                                        </div>

                                                                <div className='row'>
                                                                    <div className="d-grid gap-2 mt-2">
                                                                        {teachingPlan.length > 0 ?
                                                                            <>
                                                                                {/* <div className='search_btn_row'>
                                                                                    <input
                                                                                        className="form-control mr-sm-2"
                                                                                        type="Search"
                                                                                        placeholder="Search"
                                                                                        value={searchValue}
                                                                                        onChange={handleEmptySearch}
                                                                                        onKeyDown={(event) => {
                                                                                            if (event.key === 'Enter') {
                                                                                                handleSearch();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                                </div> */}
                                                                                <div class="generate_pdf_question_paper_report_block"  id="AIBasedTeachingReport">
                                                                                    <div class="generate_pdf_question_paper_heading">
                                                                                        <div class="generate_pdf_question_paper_logo">
                                                                                            <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                                        </div>
                                                                                        <div class="text_center">
                                                                                            {/* <h6>{teachingPlan[0]?.instituteMasterDetails?.instituteName}</h6>
                                                                                            <h4>{teachingPlan[0]?.sectionMasterDetails?.sectionName}</h4> */}
                                                                                            <h4>AI Based Teaching Report</h4>
                                                                                        </div>
                                                                                        <div class="generate_pdf_question_paper_logo">
                                                                                            <img src={"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="VidyaUpasna Logo" />
                                                                                            {/* <img src={teachingPlan[0]?.sectionMasterDetails?.logoPath} alt="Section Logo" /> */}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div class="generate_pdf_question_paper_report_code">
                                                                                        <span class="line"></span>
                                                                                    </div>

                                                                                    <div class="generate_pdf_question_paper_details">
                                                                                        <span>Syllabus: {teachingPlan[0]?.AiTeachingPlanSyllabusStructureMasterDetails?.syllabusStructureName}</span>
                                                                                        <span>Subject: {teachingPlan[0]?.subjectMasterDetails?.subjectName}</span>
                                                                                        {/* <span>Lesson: {pdfDetails?.examTotalMarks}</span> */}
                                                                                    </div>


                                                                                    <ol className="generate_pdf_question_paper_generated_pdf_total_question">
                                                                                        {teachingPlan?.map((plan, index) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {index == 0 && <div class="generate_pdf_question_paper_details">
                                                                                                        <span>Lesson: {plan?.AiTeachingPlanLessonMasterDetails?.lessonName}</span>
                                                                                                    </div>}
                                                                                                    {index !== 0 && teachingPlan[index - 1].lessonMasterId !== plan.lessonMasterId && <div class="generate_pdf_question_paper_details">
                                                                                                        <span>Lesson: {plan?.AiTeachingPlanLessonMasterDetails?.lessonName}</span>
                                                                                                    </div>}
                                                                                                    <div className="page custom_class" dangerouslySetInnerHTML={{ __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${plan?.details}</div>` }} ></div>
                                                                                                    {/* <li key={index} className="generate_pdf_question_paper_question pdf-question-paper-listed-outer">

                                                                                                        <div className='card-question-header'>
                                                                                                            <span className="list-number">{startIndex + index + 1}.</span>
                                                                                                            <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} />
                                                                                                        </div>
                                                                                                        <ul className='margin-top-10'>
                                                                                                            {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => {
                                                                                                                const optionLetter = String.fromCharCode(65 + optionIndex);
                                                                                                                return (
                                                                                                                    <li key={optionIndex} data-option={optionLetter} >
                                                                                                                        <ViewImageAndTextQuetionBank inputString={question[optionKey]} onViewImage={onViewImage} />
                                                                                                                    </li>
                                                                                                                );
                                                                                                            })}
                                                                                                        </ul>
                                                                                                        <p className="pdf-highlight"><strong>Correct Answer:</strong> {question.ans.toUpperCase()}</p>
                                                                                                        <p className="pdf-highlight"><strong>Solution:</strong><ViewImageAndTextQuetionBank inputString={question.sol} onViewImage={onViewImage} /></p>
                                                                                                    </li> */}
                                                                                                </>
                                                                                            )
                                                                                        })}
                                                                                    </ol>

                                                                                </div>
                                                                                {/* <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} /> */}
                                                                            </>
                                                                            :
                                                                            (<div className='row'>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Teaching Plan Available</th>
                                                                            </div>)}
                                                                    </div>
                                                                </div>



                                                        {/* </div> */}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AIBasedTeachingReport;